import {
  ArrowCircleLeft,
  FormatListBulleted,
  PeopleAlt,
} from "@mui/icons-material";
import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { Badge } from "@mui/material";
import jbwlogo from "../assets/jbw-logo.svg";
import { AuthContext } from "../AuthContext";
import { useAgreementSyncCount } from "../AgreementSyncCountContext";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BookIcon from '@mui/icons-material/Book';

// Agreements needing mapping or approval used to be discoverable only by opening the Agreement
// Sync screen. `badge` puts that count on the nav icon so it is visible from anywhere, and it
// stays until the work is cleared.
//
// Two MUI Badge defaults have to be overridden here, and both are requirements rather than
// preferences:
//
//   max      defaults to 99, which renders the "99+" the grooming call (2026-09-02) rejected
//            in favour of the full number. Hence max={Infinity}.
//   showZero looks like it covers "absent, not a zero" and does not go far enough. It only
//            adds a class that scales the badge to nothing -- the "0" stays in the DOM and is
//            still announced by a screen reader. So the wrapper is not rendered at all when
//            there is nothing outstanding.
const NavIcon = ({ item }) => {
  if (!item.badge) return item.icon;
  return (
    <Badge badgeContent={item.badge} color="error" max={Infinity}>
      {item.icon}
    </Badge>
  );
};

// A bare red number next to an icon says nothing on its own. The count is the whole point of
// the item, so it belongs in the link's accessible name -- and the sidebar's own label is
// display:none while it is collapsed, which is most of the time.
const navLabel = (item) =>
  item.badge ? `${item.name}, ${item.badge} awaiting mapping or approval` : item.name;

const Sidebar = (props) => {
  let { group } = useContext(AuthContext);
  const { outstandingCount } = useAgreementSyncCount();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
    props.navOpen(!isOpen);
  };

  const adminMenuItem = [
    {
      path: "overview",
      name: "Dashboard",
      icon: <DashboardIcon />,
    },
    {
      path: "onboardinghome",
      name: "Dealers",
      icon: <FormatListBulleted />,
    },
    {
      path: "userslist",
      name: "Users",
      icon: <PeopleAlt />,
    },
    /*{
      path: "todohome",
      name: "ToDo",
      icon: <FactCheckIcon />,
    },*/
    {
      path: "agreementssynchome",
      name: "AgreementsSync",
      icon: <AssignmentIcon />,
      badge: outstandingCount,
    },
    {
      path: "transactionlog",
      name: "Transaction Log",
      icon: <BookIcon />,
    },
  ];

  const dealerMenuItem = [
    {
      path: "dealerdetails",
      name: "Dashboard",
      icon: <DashboardIcon />,
    },
    /*{
      path: "todohome",
      name: "ToDo",
      icon: <FactCheckIcon />,
    },*/
    {
      path: "agreementssynchome",
      name: "AgreementsSync",
      icon: <AssignmentIcon />,
      badge: outstandingCount,
    },
    {
      path: "transactionlog",
      name: "Transaction Log",
      icon: <BookIcon />,
    },
  ];
  return (
    <div style={{ width: isOpen ? "200px" : "60px" }} className="sidebar">
      <div className="top_section">
        <div className="logo" style={{ display: isOpen ? "block" : "none" }}>
          <img src={jbwlogo} alt="JBW-LOGO" height={100} />
        </div>
        <div
          style={{
            marginLeft: isOpen ? "15px" : "0px",
          }}
          className="bars"
        >
          {isOpen ? (
            <ArrowCircleLeft onClick={toggle} />
          ) : (
            <div className="logo" onClick={toggle}>
              <img
                src={jbwlogo}
                alt="JBW-LOGO"
                style={{
                  width: "40px",
                  height: "40px",
                }}
              />
            </div>
          )}
        </div>
      </div>
      {group === "jbw-dealer"
        ? dealerMenuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className="link"
              activeclassname="active"
              aria-label={navLabel(item)}
            >
              <div className="icon">
                <NavIcon item={item} />
              </div>
              <div
                style={{ display: isOpen ? "block" : "none", fontSize: 14 }}
                className="link_text"
              >
                {item.name}
              </div>
            </NavLink>
          ))
        : adminMenuItem.map((item, index) => (
            <NavLink
              to={item.path}
              key={index}
              className="link"
              activeclassname="active"
              aria-label={navLabel(item)}
            >
              <div className="icon">
                <NavIcon item={item} />
              </div>
              <div
                style={{ display: isOpen ? "block" : "none", fontSize: 14 }}
                className="link_text"
              >
                {item.name}
              </div>
            </NavLink>
          ))}
    </div>
  );
};

export default Sidebar;
